import type { RouteRecordRaw } from "vue-router";
import ParticipationRequestPage from "./ParticipationRequestPage.vue";
import PublicCanvassPage from "./PublicCanvassPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/s/:shortUrlId",
    name: "publicCanvass",
    component: PublicCanvassPage,
    props: true,
  },
  {
    path: "/onboarding/join/:canvassId",
    name: "participationRequest",
    component: ParticipationRequestPage,
    props: true,
  },
];

export default routes;
